// extracted by mini-css-extract-plugin
export default {"AlbumSection":"AlbumSection_AlbumSection__oxt8+"};